import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import "./Contact.scss";
import Testimonials from "../../components/Testimonials/Testimonials";
import { Link } from "react-router-dom";

function ContactPage() {
  return (
    <>
      <div className="contact-wrap">
        <div className="container">
          <div className="heading ">
            <Slide direction="up">
              <h3>Our Office</h3>
            </Slide>
          </div>
          <div className="content  ">
            <Fade>
              <div className="contact-info">
                <h6>
                  {" "}
                  <b>Meerut Cantt (U.P), &nbsp; India</b>
                </h6>
                <p>
                  Nand Puri,
                  <br /> Kanker Khera Meerut Cantt, Meerut, India, 250001
                </p>
                <p>
                  <Link to="tel:91 9758635932">+91 9758635932</Link> |
                  <Link to="mailto:wowWishMoments@gmail.com">
                    &nbsp; WowWishMoments@gmail.com
                  </Link>
                </p>
              </div>
            </Fade>

            <div className="contact-points spacing">
              <div className="cop-inner">
                <Fade>
                  <h4>Point Of Contacts</h4>
                  <h5>Feel Free to contact us for any queries/details.</h5>
                </Fade>
                <div className="cop-content">
                  <Link
                    to="mailto:wowwishmoments@gmail.com"
                    className="cop-items"
                  >
                    <Fade>
                      <div className="inner">
                        <h6>
                          <b>GENERAL</b>
                        </h6>
                        <p>For General Inquires</p>
                        <p>
                          <b>WowWishMoments@gmail.com</b>
                        </p>
                      </div>
                    </Fade>
                  </Link>

                  <Link
                    to="mailto:wowwishmoments@gmail.com"
                    className="cop-items"
                  >
                    <Fade>
                      <div className="inner">
                        <h6>
                          <b>PARTNERSHIPS</b>
                        </h6>
                        <p>
                          For vendors and talent interested in working with us:
                        </p>
                        <p>
                          <b>WowWishMoments@gmail.com</b>
                        </p>
                      </div>
                    </Fade>
                  </Link>

                  <Link
                    to="mailto:wowwishmoments@gmail.com"
                    className="cop-items"
                  >
                    <Fade>
                      <div className="inner">
                        <h6>
                          <b>CAREERS</b>
                        </h6>
                        <p>To inquire about internships or positions</p>
                        <p>
                          <b>WowWishMoments@gmail.com</b>
                        </p>
                      </div>
                    </Fade>
                  </Link>
                </div>
              </div>
            </div>

            <div className="ab-testimonials spacing">
              <div className="container">
                <div className="row">
                  <div className="r-col">
                    <Fade>
                      <h3>Testimonials</h3>
                    </Fade>
                  </div>
                  <Testimonials />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="map-sec  ">
        <div className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d872.25275044803!2d77.68318382923437!3d29.016664171659308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c6596ca8fab1d%3A0xd2a839d15e32fbd2!2s9%2F3%2C%20New%20Ashok%20Puri%2C%20Nand%20Puri%2C%20Meerut%2C%20Uttar%20Pradesh%20250001!5e0!3m2!1sen!2sin!4v1680178143886!5m2!1sen!2sin"
            width="600"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
